<!-- Security & Compliance Page -->
<section class="sec-pad">
  <div class="container">
    <h1><i class="fa fa-shield fa-fw"></i> Security &amp; Compliance</h1>
    <p class="lead">
      Your patient data is protected by industry-leading safeguards.
    </p>
    <p>At WellWink, we understand that security isn't just a feature—it’s the foundation of modern healthcare. We employ
      a
      multi-layered security strategy to ensure your practice remains compliant and your patient's "Protected Health
      Information" (PHI) stays private.</p>
    <div>
      <hr class="hr-line">
      <strong>1. HIPAA & Regulatory Compliance</strong>
      <p>We are fully committed to the Health Insurance Portability and Accountability Act (HIPAA) standards.</p>
      <ul>
        <li><b>Business Associate Agreement (BAA):</b> WellWink signs a formal BAA with every covered entity to clearly
          define our responsibilities in protecting your data.
        </li>
        <li><b>Regular Audits:</b> We conduct internal and third-party security audits to identify and mitigate risks
          before they arise.
        </li>
        <li><b>Training:</b> Every WellWink employee undergoes mandatory HIPAA privacy and security training.
        </li>
      </ul>
    </div>
    <div>
      <hr class="hr-line">
      <strong>2. Data Encryption</strong>
      <p>Your data is shielded whether it is sitting on our servers or traveling across the internet.</p>
      <ul>
        <li><b>In Transit:</b> All data sent between your browser and our servers is protected
          using high-grade TLS 1.2+ encryption.
        </li>
        <li><b>At Rest:</b> Patient records and sensitive databases are encrypted using AES-256, the same standard
          used by global financial institutions.
        </li>
      </ul>
    </div>
    <div>
      <hr class="hr-line">
      <strong>3. Access & Identity Management</strong>
      <p>We ensure that only the right people have access to sensitive information.</p>
      <ul>
        <li><b>Multi-Factor Authentication (MFA):</b> Add an extra layer of security to your login process to prevent
          unauthorized access.
        </li>
        <li><b>Role-Based Access Control (RBAC):</b> Grant permissions based on staff roles (e.g., front desk vs.
          physician) so users only see the data they need to do their jobs.
        </li>
        <li><b>Automatic Session Timeouts:</b> To prevent data exposure on shared office computers, sessions
          automatically log out after a period of inactivity.
        </li>
      </ul>
    </div>
    <div>
      <hr class="hr-line">
      <strong>4. Infrastructure & Resilience</strong>
      <p>WellWink is hosted on world-class, SOC 2 Type II compliant cloud infrastructure</p>
      <ul>
        <li><b>99.9% Uptime:</b> Our redundant server architecture ensures your practice management
          tools are available when you need them most.
        </li>
        <li><b>Disaster Recovery:</b> We perform daily encrypted backups across multiple geographic locations to ensure
          data can be recovered in any scenario.
        </li>
        <li><b>Physical Security:</b> Our data centers feature 24/7 guarded monitoring, biometric access
          points, and advanced fire suppression.
        </li>
      </ul>
    </div>
  </div>
</section>
